import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo';
import { SmartLinkWidgetType } from 'fym-common/src/db/enums';
import { TypedMemo } from '../../../common/types';
import { useSMLRouter } from '../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { SMLSettingsTabId } from '../../../settings/tabs/types';
import { formMessages } from './formMessages';
import { socialMessages } from './socialMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for every block form */
import styles from './SMLBlockForm.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The Profile block (design d7): read only. It shows the artist photo, name and bio of the account;
 * the button opens Settings → Artist in the same tab, and Back returns to this row.
 */
const ProfileBlockFormComponent: React.FC = () => {
  const intl = useIntl();
  const router = useSMLRouter();
  const openSettings = useCallback(() => router.push(SMLRoutes.settings, { tab: SMLSettingsTabId.artist }), [router]);

  return (
    <div className={styles.form} data-testid={`form-${SmartLinkWidgetType.profile}`}>
      <p className={styles.note}>
        <FontAwesomeIcon icon={faCircleInfo} className={styles.noteIcon} />
        {intl.formatMessage(formMessages.profileNote)}
      </p>
      <button type="button" className={styles.secondaryButton} onClick={openSettings}>
        {intl.formatMessage(socialMessages.openArtistSettings)}
      </button>
    </div>
  );
};

export const ProfileBlockForm = TypedMemo(ProfileBlockFormComponent);
